<script>
  export default {
    props: {
      value: {
        type: [Number,
          String],
        default: 0
      },
      title: {
        type: String,
        default: ''
      },
      list: {
        type: Array,
        default: () => {
          return [
            {
              text: '標題',
              to: 'home' // routeName
            }
          ]
        }
      },
      type: {
        type: String,
        default: '',
        validator(value) {
          return [
            '',
            'holderHover',
          ].includes(value)
        },
      },
      isProductNav: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onEnterMenu(item, index) {
        this.$emit('enterMenu', item, index);
        this.$emit('input', index);
      },
      onLeaveMenu(item, index) {
        this.$emit('leaveMenu', item, index);
      },
      onClick(item, index) {
        this.$emit('clickMenu', item, index);
      }
    }
  }
</script>
<template>
  <div class="baseMenu" :class="{ isProductNav: isProductNav }">
    <div
      v-if="title"
      class="baseMenu__title mb-3"
    >
      {{ title }}
    </div>
    <ul class="baseMenu__list">
      <li class="baseMenu__item">
        <template v-for="(item, index) in list">
          <a
            v-if="item.path"
            :key="index"
            :href="item.path"
            target="_blank"
            class="baseMenu__link"
            :class="{ isActive: value === index && type === 'holderHover' }"
            @mouseenter="onEnterMenu(item, index)"
            @mouseleave="onLeaveMenu(item, index)"
          >
            {{ item.text || item.title }} <i class="fal fa-external-link-alt"></i>

          </a>
          <router-link
            v-else-if="item.to && !item.path"
            :key="index"
            :to="item.to"
            class="baseMenu__link"
            :class="{ isActive: value === index && type === 'holderHover' }"
            @mouseenter.native="onEnterMenu(item, index)"
            @mouseleave.native="onLeaveMenu(item, index)"
          >
            {{ item.text || item.title }}
          </router-link>
          <div
            v-else
            :key="index"
            class="baseMenu__link"
            :class="{ isActive: value === index && type === 'holderHover' }"
            @mouseenter="onEnterMenu(item, index)"
            @mouseleave="onLeaveMenu(item, index)"
            @click="onClick(item, index)"
          >
            {{ item.text || item.title }}
          </div>
        </template>
      </li>
    </ul>
  </div>
</template>
<style lang="scss">
  .baseMenu {
    padding: 1.5rem 0;
    background: #FFF;

    &.isGrayLight {
      background: #FAFAFA;
    }

    &.point {
      .baseMenu__item {
        .baseMenu__link {
          cursor: pointer;
        }
      }
    }

    &.isDownMark {
      .baseMenu__title {
        position: relative;

        &::after {
          position: absolute;
          top: 0;
          right: 9px;
          font-family: 'Font Awesome 5 Pro';
          font-size: 1.25rem;
          content: '\f175';
          animation-name: slideDown;
          animation-duration: 1.7s;
          animation-iteration-count: infinite
        }
      }
    }

    &__title {
      padding: 1rem 5rem;
      font-size: 1.25rem;
      font-weight: 500;

      @media screen and (max-width: #{$container + ($container-gap * 2)}) {
        padding: 1rem 3rem;
      }
    }

    &__list {
      padding-left: 0;
      margin-bottom: 0;
    }

    &__item {
      list-style: none;
    }

    &__link {
      display: block;
      padding: 1rem 5rem;
      color: $color-gray-7;

      @media screen and (max-width: #{$container + ($container-gap * 2)}) {
        padding: 1rem 3rem;
      }

      &.router-link-active {
        // color: $color-primary
      }

      &.isActive, &:hover, &:active {
        color: #FFF;
        text-decoration: none;
        background: $color-primary;
      }
    }

    &.isProductNav {
      .baseMenu__item {
        font-size: 1.25rem;
        font-weight: 500;
      }

      .baseMenu__link {
        padding-top: 1.25rem;
        padding-right: 0;
        padding-bottom: 1.25rem;
        padding-left: 4rem;

        @include max-xl {
          padding-left: 3rem;
        }
      }
    }
  }

  @keyframes slideDown {
    0% {
      top: 0;
      opacity: 1;
    }
    to {
      top: 50%;
      opacity: 0;
    }
  }
</style>
